import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { LongTermCollaborationSection } from './components/LongTermCollaborationSection';
import { ContactSection } from './components/ContactSection';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <LongTermCollaborationSection data-id="element-5" />
        <ContactSection data-id="element-6" />
      </main>
      <footer className="py-6 bg-white border-t border-gray-100" data-id="element-7">
        <div className="container mx-auto px-6" data-id="element-8">
          <p className="text-sm text-gray-500" data-id="element-9">
            © {new Date().getFullYear()} Sandor Moricz. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}